import script from "./defaultLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./defaultLayout.vue?vue&type=script&lang=ts&setup=true"

import "./defaultLayout.vue?vue&type=style&index=0&id=06b2d18d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06b2d18d"]])

export default __exports__